export enum RoleActivityName {
  CLINICAL_TRIALS_ACCESS = 'clinicaltrial.access',
  DASHBOARD_ACCESS = 'dashboard.access',
  DASHBOARD_LIST_PROJECTS = 'dashboard.list.projects',
  DASHBOARD_LIST_BATCHES = 'dashboard.list.batches',
  AUDITTRAILS_ACCESS = 'audittrails.access'
}
